"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useState } from "react";
import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { useGlobalParams } from "@travel/shared/global/data-access";
import { useConfig } from "../use-config/use-config";
export function useAPI(request, apiFetcher, options) {
    var _this = this;
    var _a;
    var _b = useConfig(), partnerID = _b.partnerID, refID = _b.refID, sourceCode = _b.app;
    var _c = __read(useGlobalParams(), 1), _d = _c[0], campaign = _d.campaign, ad = _d.ad, cid = _d.cid;
    var _e = __read(useState(), 2), mutationError = _e[0], setMutationError = _e[1];
    var fetcher = useCallback(function (url, request) { return __awaiter(_this, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (Array.isArray(url)) {
                        request = url[1];
                        url = url[0];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiFetcher(__assign(__assign({}, ((request === null || request === void 0 ? void 0 : request.arg) || request)), { campaign: campaign, ad: ad, cid: cid }), __assign(__assign({}, options), { sourceCode: sourceCode, partnerID: partnerID }))];
                case 2:
                    result = _a.sent();
                    return [2 /*return*/, result];
                case 3:
                    error_1 = _a.sent();
                    if (options === null || options === void 0 ? void 0 : options.mutation) {
                        setMutationError(error_1);
                    }
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    }); }, [apiFetcher, options === null || options === void 0 ? void 0 : options.headers, options === null || options === void 0 ? void 0 : options.mutation, campaign, ad, cid]);
    var fullRequest = request
        ? __assign(__assign({}, request), { partnerID: partnerID, refClickID: refID || partnerID, campaign: campaign, ad: ad, cid: cid }) : null;
    var swr = useSWR(!(options === null || options === void 0 ? void 0 : options.mutation) && request
        ? [apiFetcher.url(fullRequest), fullRequest]
        : null, fetcher, options);
    var mutation = useSWRMutation((options === null || options === void 0 ? void 0 : options.mutation) ? (_a = apiFetcher.url) === null || _a === void 0 ? void 0 : _a.call(apiFetcher, fullRequest || {}) : null, fetcher, __assign(__assign({}, options), { throwOnError: false }));
    return __assign(__assign({}, ((options === null || options === void 0 ? void 0 : options.mutation)
        ? __assign({}, mutation) : swr)), { isLoading: (options === null || options === void 0 ? void 0 : options.mutation) ? mutation.isMutating : swr.isLoading, trigger: function (request) {
            if (!(options === null || options === void 0 ? void 0 : options.mutation))
                return;
            var fullRequest = request
                ? __assign(__assign({}, request), { partnerID: partnerID, refClickID: refID || partnerID, campaign: campaign, ad: ad, cid: cid }) : null;
            setMutationError(null);
            mutation.trigger(fullRequest);
        } });
}
